import AppLayout from "@/layouts/AppLayout";
import { Outlet } from "react-router-dom";
import { PersonObjectHeading } from "@/features/person/components/PersonObjectHeading";
import { usePersonErrorHandling } from "../_components/usePersonErrorHandling";
import PersonNotFoundErrorBoundary from "../_components/PersonNotFoundErrorBoundary";
import Breadcrumb from "@/components/Breadcrumb";

export default function AdminToolsLayout() {
  const { pgaId, navLinks, shouldRenderError } = usePersonErrorHandling();

  if (shouldRenderError || !pgaId) {
    return (
      <AppLayout navLinks={[]} interior bottomBar>
        <PersonNotFoundErrorBoundary />
      </AppLayout>
    );
  }

  return (
    <AppLayout navLinks={navLinks} interior bottomBar>
      <Breadcrumb compactOnly compactTitle="Admin Tools" backLink={{ to: "/people/:pgaId", params: { pgaId } }} />
      <PersonObjectHeading pgaId={pgaId} />
      <Outlet />
    </AppLayout>
  );
}
